import type { DrillTopic } from "./Drill";

// Темы про смерти: на их карточке — ещё и выживаемость по быстрой оценке матчей.
export const DEATH_TOPICS: ReadonlySet<DrillTopic> = new Set(["killer"]);
